import { render, staticRenderFns } from "./full-slot.vue?vue&type=template&id=bb521078"
import script from "./full-slot.vue?vue&type=script&lang=js"
export * from "./full-slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports